import React from 'react';
import { formatPromotionPeriod } from '../promo/promoUtils.js';

function EventPromotionBadge({ promotion }) {
  if (!promotion) {
    return null;
  }

  const isActive = promotion.status === 'ACTIVE';
  const badgeClass = isActive
    ? 'event-promotion-badge event-promotion-badge--active'
    : 'event-promotion-badge event-promotion-badge--scheduled';

  const label = isActive
    ? `Promowane · ${promotion.planLabel}`
    : `Zaplanowane · ${promotion.planLabel}`;

  const period = formatPromotionPeriod(promotion.startsAt, promotion.endsAt);

  return (
    <span className={badgeClass} title={period !== '—' ? period : undefined}>
      <span className="event-promotion-badge__label">{label}</span>
      {period !== '—' && (
        <span className="event-promotion-badge__period">{period}</span>
      )}
    </span>
  );
}

export default EventPromotionBadge;
